import { isOwnShareCode } from './ownShareCodes';
/**
 * A signed-out viewer looking at a share code that was not generated in this
 * tab. `checkAuth` cannot match a guest against a code's owner, so it leaves
 * isAdmin `true` for them — correct for their own blank workspace, but it would
 * otherwise open someone else's code in edit mode, and edit mode is what lets
 * the toolbox bypass the hidden-manipulative filter (ManipulativeTool reads
 * `isAdmin && viewEditMode === 'edit'`). Same ownership rule ButtonGroup uses to
 * hide the view/edit toggle from a guest, and intentionally the SAME three
 * clauses — a guest on a foreign code must land exactly where a logged-in
 * non-owner lands.
 *
 * Deliberately NOT conditioned on manipulativeBtnState. A null state means the
 * activity configures no tools, and ManipulativeTool renders that as an EMPTY
 * toolbox for anyone on the filtered path — which is already what a logged-in
 * non-owner sees, and is the intended "author hid everything" result. An earlier
 * revision skipped view mode when the state was null, to avoid stripping the
 * toolbox for a guest on a legacy or expired code; that inverted the meaning of
 * null and let the original bug through for real activities. Guests now match
 * logged-in non-owners in every case, including the empty-toolbox one.
 */
export function isGuestOnForeignCode(input) {
    var isLoggedIn = input.isLoggedIn, shareCode = input.shareCode;
    return !isLoggedIn && !!shareCode && !isOwnShareCode(shareCode);
}
/** The view/edit mode the player should open in for the given viewer. */
export function initialViewEditMode(input) {
    return input.isAdmin && !isGuestOnForeignCode(input) ? 'edit' : 'view';
}
